import { JetView } from 'webix-jet';
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterApprovalLogsView.
 * @extends JetView
 */
export default class FilterApprovalLogsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Left section of the filter form
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for date picker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for date input
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Visibility based on permissions
                            ),
                            css: 'prm-filterByUser',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Label for user ID input
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'UserName',
                            label: "<span class='icon-mail'></span>" + _('Usuario (Correo electrónico)'), // Label for username input
                            labelPosition: 'top',
                            placeholder: _('Usuario (Correo electrónico)'), // Placeholder text
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for country selection
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Country option template
                                        );
                                    },
                                    data: countries, // Country data source
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Visibility based on permissions
                                ),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for second country selection
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default selected country
                            readonly: true, // Make this field read-only
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Country option template
                                        );
                                    },
                                    data: countries, // Country data source
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Visibility based on permissions
                                ),
                            css: 'prm-filterByCountry',
                            css: 'country-hide',
                        },
                    ],
                },
            ],
        };

        // Second left section of the filter form
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'State',
                            label: _('Estado'), // Label for state selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar'), // Placeholder text
                            options: [
                                { id: '', value: _('Pendiente') }, // Pending state option
                                { id: '0', value: _('Aprobada') }, // Approved state option
                                { id: '1', value: _('Rechazada') }, // Rejected state option
                            ],
                        },
                        {
                            view: 'text',
                            name: 'Field',
                            label: _('Campo'), // Label for field input
                            labelPosition: 'top',
                            placeholder: _('Campo'), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'UserNameRequest',
                            label: _('Usuario Solicita'), // Label for request user input
                            labelPosition: 'top',
                            placeholder: _('Usuario Solicita'), // Placeholder text
                        },
                    ],
                },
            ],
        };

        // Upper section of the filter form
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Contains the first left section
                },
            ],
        };

        // Second upper section of the filter form
        const upper_section2 = {
            css: 'father-container',
            height: screen.width < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Contains the second left section
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Contains the second upper section
                            },
                        },
                    ],
                },
            ],
        };

        // Button section for filter actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear the filter form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button label
                    hotkey: 'enter', // Shortcut key
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('requests:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Second button section for filter actions
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button label
                    click: () => {
                        $$('myForm2').clear(); // Clear the second filter form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button label
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get filter values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('requests:filter', [filterdata]); // Trigger filter event
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };

        // Accordion section for main filters
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for main filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Contains the upper section
                                    accordion_section, // Contains the advanced filters
                                    buttons, // Contains the action buttons
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        // Scrollable section for filters
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section, accordion_section], // Contains the upper section and advanced filters
            },
        };

        // Popup window for filters
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Contains the scrollable section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });

        // Main filter form configuration
        return {
            view: 'form',
            type: 'clean',
            id: 'formFilter',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion section if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if not applicable
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input if applicable
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
